// Core
import { useState, useEffect, useCallback, useMemo } from 'react';
import { useQuery } from 'react-query';
import {
  Button,
  Box,
  Grid,
  Flex,
  Text,
  FormControl,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useColorModeValue,
  useDisclosure
} from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

// Accets
import { apiService } from 'services/ApiService';
import { ReactComponent as EditIcon } from 'assets/svg/edit.svg';

// Components
import Card from 'components/Card/Card';
import ErrorCard from 'components/Form/Errors';
import EditField from 'components/Form/EditField';
import EditSelect from 'components/Form/EditSelect';
import CodeModal from 'components/Modals/CodeModal';

const DeleteAccount = ({ userData }) => {
	const [errorCard, setErrorCard] = useState();

	const handleChange = async (code) => {
		setErrorCard();
		try {
			let response = {};
			if(code){
				response = await apiService.deleteUser({code});
			} else {
				response = await apiService.deleteUser();
			}
			
			if(response.data === false || 
				response.data.status === false || 
				response.statusCode !== 200 || 
				response.statusCode === 404){
				//setErrorCard(response.data.errorMessage);
				setIsValidCode(false);
				return;
			} else if(response.statusCode === 200 && response.data.status === true){
	          startTimer(); // stop
	          startTimer(); // start
	        }
		} catch(e){
			setErrorCard('An unknown error occurred, try changing the fields or refreshing the page');
			setTimeout(function() { onClose(); }, 1000);
			return;
		}

		if(code){
			localStorage.removeItem('auth');
			window.location.href = '/auth/login';	
		}
	};

	const [editMode, setEditMode] = useState(false);

	const { isOpen, onClose, onOpen } = useDisclosure();
	const [seconds, setSeconds] = useState(59);
  	const [timerActive, setTimerActive] = useState(false);
	useEffect(() => {
	    let interval = null;
	    
	    if (timerActive && seconds > 0) {
	      interval = setInterval(() => {
	        setSeconds(seconds => seconds - 1);
	      }, 1000);
	    } else if (!timerActive && seconds !== 0) {
	      clearInterval(interval);
	    } else if (seconds === 0) {
	      setTimerActive(false);
	    }

	    return () => clearInterval(interval);
	}, [timerActive, seconds]);
	const [isValidCode, setIsValidCode] = useState(true);
	const startTimer = () => {
	    setTimerActive(true);
	    setSeconds(59);  
	};

	const { isOpen: isOpenPreDelete, onClose: onClosePreDelete, onOpen: onOpenPreDelete } = useDisclosure();
 
	return (
		<Box mt="8px">
			{ errorCard && ( <ErrorCard error={errorCard} /> )}

			<Grid templateColumns={{ sm: '1fr', md: '1fr 1fr ' }} gap="8px">
				<Box w="100%">
					<NavLink to="/account/membership">
						<Button variant="secondary-lg">Cancel Subscription</Button>
					</NavLink>
				</Box>

				<Button w="100%" onClick={onOpenPreDelete}  
				variant="secondary-lg" color="#FF6C64">Delete Account</Button>
			</Grid>

			<Modal isOpen={isOpenPreDelete} onClose={onClosePreDelete}>
        <ModalOverlay />
        <ModalContent className="modal__simple modal_delete" 
            maxW={{ sm: '480px' }} 
            style={{ border:'1px solid #2ABDFD', overflow: 'hidden' }}>
        <ModalCloseButton style={{zIndex: '9'}} />
            <Box bg="rgba(64, 155, 255, 0.82)" filter="blur(70px)" w="90%" h="150px"
                transform="translate(-50%, 0px)" left="50%" 
                top="-200px" position="absolute" borderRadius="full" />

            <Box position="relative" p="0 8px 0 8px" textAlign="center">
                <Text 
                  variant="title-lg"
                  zIndex="3" 
                  pt="24px"
                  fontSize="32px"
                  fontStyle="italic"
                  fontWeight="700"
                  position="relative">Before you delete your account</Text>

                <Text mt="16px" fontStyle="italic" mb="16px">
                  If you have any active memberships, please cancel them first. Deleting your account does not automatically cancel or refund memberships.
                </Text>

                <NavLink to="/account/membership">
									<Button variant="button-md" mt="16px">Cancel Subscription</Button>
								</NavLink>
                <Button variant="secondary-md" mt="16px" onClick={() => {
                  	handleChange(null); 
                  	onOpen(); 
                  	startTimer();
                  	onClosePreDelete();
                	} 
                }>Delete Account</Button>
                <Button variant="solid-md" mt="16px" onClick={() => { onClosePreDelete(); }}>Back</Button>
            </Box>
        </ModalContent>
      </Modal> 

			<CodeModal
        handle={handleChange}
        seconds={seconds} 
		    startTimer={startTimer} 
		    timerActive={timerActive} 
		    isValidCode={isValidCode} 
		    setIsValidCode={setIsValidCode}
        isOpen={isOpen}
        onClose={onClose}
        errorCard={errorCard}
        title="Delete account"
        description="A verification code has been sent to the your email. Please enter it below." 
        />
		</Box>
	);
};


export default DeleteAccount;